import { SVGProps } from 'react'

function Clock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={10.5}
      height={10.5}
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M18 2.25C9.302 2.25 2.25 9.302 2.25 18S9.302 33.75 18 33.75 33.75 26.698 33.75 18 26.698 2.25 18 2.25zm0 28.828c-7.221 0-13.078-5.857-13.078-13.078 0-7.221 5.857-13.078 13.078-13.078 7.221 0 13.078 5.857 13.078 13.078 0 7.221-5.857 13.078-13.078 13.078z'
        fill='currentColor'
      />
      <path
        d='M24.142 22.447l-5.013-3.624v-8.701a.282.282 0 00-.282-.282h-1.69a.282.282 0 00-.282.282v9.682c0 .091.042.175.116.228l5.815 4.24a.284.284 0 00.394-.06l1.005-1.37a.28.28 0 00-.063-.395z'
        fill='currentColor'
      />
    </svg>
  )
}

export default Clock
